import { StyleSheet } from 'react-native';

export const sharedPromptStyles = StyleSheet.create({
  cancelIcon: {
    display: 'flex',
    alignSelf: 'flex-end'
  },
  titleContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 20,
    marginTop: 10
  },
  buttonContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    gap: 15
  },
  buttonContainerMobile: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    gap: 12
  }
});

export const basePromptContainer = {
  backgroundColor: '#d3dfea',
  paddingHorizontal: 20,
  paddingVertical: 15,
  width: '90%',
  marginTop: 0,
  borderColor: '#e8971a',
  borderWidth: 3,
  borderRadius: 10,
  elevation: 5,
  shadowColor: '#000',
  shadowOffset: { width: 0, height: 2 },
  shadowOpacity: 0.25,
  shadowRadius: 3.84,
  position: 'relative'
};

export const baseResponseView = {
  flex: 1,
  alignItems: 'center',
  position: 'absolute',
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.4)',
  width: '100%',
  height: '100%'
};

export const baseTitleText = {
  fontFamily: 'Poppins_300Light',
  fontSize: 20,
  textAlign: 'center',
  color: '#000',
  fontWeight: '500'
};

export const baseButtonText = {
  color: '#1C1C1C',
  fontFamily: 'Poppins_300Light',
  fontSize: 16,
  textShadowColor: 'rgba(0, 0, 0, 0.25)',
  textShadowOffset: { width: 1, height: 1 },
  textShadowRadius: 2,
  fontWeight: '500'
};

export const baseActionButton = {
  borderWidth: 1,
  borderColor: '#1C1C1C',
  borderRadius: 20,
  paddingHorizontal: 16,
  alignItems: 'center',
  justifyContent: 'center'
};

